
import { ExerciseForm } from "../../../../exercise/ExerciseForm";
import { toast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

interface ExerciseFormSectionProps {
  showExerciseForm: boolean;
  routineId: string;
  onExerciseAdded: () => void;
}

export const ExerciseFormSection = ({
  showExerciseForm,
  routineId,
  onExerciseAdded,
}: ExerciseFormSectionProps) => {
  const handleAddExercise = async (name: string) => {
    if (!routineId) return;

    try {
      // Get the current max position for the routine
      const { data: maxPositionData, error: maxPositionError } = await supabase
        .from("exercises")
        .select("position")
        .eq("routine_id", routineId)
        .order("position", { ascending: false })
        .limit(1);

      if (maxPositionError) throw maxPositionError;

      const nextPosition = maxPositionData && maxPositionData.length > 0 
        ? maxPositionData[0].position + 1 
        : 1;

      const { data, error } = await supabase
        .from('exercises')
        .insert({
          routine_id: routineId,
          name,
          sets: 3,
          reps: 12,
          weight: 0,
          position: nextPosition,
          set_data: Array(3).fill({ reps: 12, weight: 0 })
        })
        .select()
        .single();

      if (error) throw error;

      toast({
        title: "Ejercicio añadido",
        description: "El ejercicio ha sido añadido exitosamente",
        variant: "success"
      });

      console.log("🎯 Exercise created successfully - triggering minimal update to preserve tab state");
      
      // Trigger minimal update instead of full refetch to preserve navigation state
      onExerciseAdded();
      
    } catch (error) {
      console.error('Error adding exercise:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "No se pudo añadir el ejercicio",
      });
    }
  };

  if (!showExerciseForm) return null;

  return <ExerciseForm onSubmit={handleAddExercise} />;
};
